import {DestroyRef, inject, Injectable} from '@angular/core';
import {switchMap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EVENT_BUS} from "../../../../../shared/domain/tokens/event-bus.token";
import {
  BookingTicketGeneratedEvent
} from "../../../../../shared/application/events/ticket/booking-ticket-generated.event";
import {PaymentsCommonService} from "../../../../services/payments/payments-common.service";

@Injectable()
export class UpdateSerieOnTicketGeneratedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly paymentsCommonService = inject(PaymentsCommonService);


  constructor() {
    this.eventBus.ofType(BookingTicketGeneratedEvent)
      .pipe(
        switchMap(({payload: ticket}) => this.paymentsCommonService.handleTicketInsertion(ticket, true)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
